import { render, staticRenderFns } from "./CoordinateActivity.vue?vue&type=template&id=25bb6f40&scoped=true"
import script from "./CoordinateActivity.vue?vue&type=script&lang=js"
export * from "./CoordinateActivity.vue?vue&type=script&lang=js"
import style0 from "./CoordinateActivity.vue?vue&type=style&index=0&id=25bb6f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb6f40",
  null
  
)

export default component.exports